import * as React from "react";
import { useMemo } from "react";
import { isPermitted } from "util/PermissionsMixin";
import useCurrentUser from "hooks/useCurrentUser";
import { Button } from "components/bootstrap";
import { DataWell } from "common/components";
import EvidenceSectionHeader from "security-app/components/Investigations/Details/OverviewSegment/EvidenceSectionHeader";
import Routes from "routing/Routes";
import LogsList from "./LogsList";
import useGoToEvidencePage from "./useGoToEvidencePage";
function Logs({ investigation, isExpanded, onToggleExpanded }) {
  const { permissions } = useCurrentUser();
  const goToLogs = useGoToEvidencePage(investigation.id, Routes.SEARCH);
  const canManageEvidence = useMemo(
    () => !investigation.archived && isPermitted(permissions, "investigations:edit"),
    [investigation.archived, permissions]
  );
  return /* @__PURE__ */ React.createElement(DataWell, { $color: "content" }, /* @__PURE__ */ React.createElement(
    EvidenceSectionHeader,
    {
      sectionName: "logs",
      title: "Logs",
      count: investigation.logs_count,
      isExpanded,
      onToggleExpanded,
      action: canManageEvidence ? /* @__PURE__ */ React.createElement(Button, { onClick: goToLogs }, "Go to Search") : null
    }
  ), isExpanded && /* @__PURE__ */ React.createElement("div", { style: { marginTop: "0.5rem" } }, /* @__PURE__ */ React.createElement(LogsList, { investigation })));
}
export default Logs;
